module.exports = (__webpack_require__(4))(228);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/hoist-non-react-statics/index.js from dll-reference carbon.vendor
// module id = 55
// module chunks = 0